webpackJsonp([213534597649335],{

/***/ 89:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _logoContainerStyle;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Logo = __webpack_require__(44);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	__webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header() {
	    _classCallCheck(this, Header);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Header.prototype.render = function render() {
	    return _react2.default.createElement(
	      'nav',
	      { style: navStyle },
	      _react2.default.createElement(
	        'div',
	        { style: logoContainerStyle },
	        _react2.default.createElement(_Logo2.default, null)
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	var navStyle = {
	  top: 10,
	  verticalAlign: 'top',
	  paddingTop: '2.78%',
	  width: '100%',
	  zIndex: 1,
	  textAlign: 'center',
	  fontSize: '22px',
	  // display: 'block',
	  WebkitFontSmoothing: 'antialiased',
	  textRendering: 'optimizeSpeed',
	  cursor: 'pointer'
	};
	
	var logoContainerStyle = (_logoContainerStyle = {
	  verticalAlign: 'middle',
	  textAlign: 'center',
	  whiteSpace: 'nowrap',
	  fontSize: '22px',
	  height: '50px'
	}, _logoContainerStyle['textAlign'] = 'center !important', _logoContainerStyle.border = 0, _logoContainerStyle.margin = 'auto', _logoContainerStyle.padding = 0, _logoContainerStyle.cursor = 'pointer', _logoContainerStyle);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 131:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Logo = function Logo() {
	  return _react2.default.createElement(
	    'a',
	    { href: 'https://altola.co', className: 'logo-link' },
	    _react2.default.createElement(
	      'svg',
	      { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 229.2 27.38', style: { width: '150px' } },
	      _react2.default.createElement(
	        'g',
	        { id: 'Layer_2', 'data-name': 'Layer 2' },
	        _react2.default.createElement(
	          'g',
	          { id: 'Layer_1-2', 'data-name': 'Layer 1' },
	          _react2.default.createElement('polygon', { className: 'logo', points: '11.72 0.64 0 26.79 6.27 26.79 7.42 24.07 8.18 22.3 10.38 17.15 11.66 14.13 14.89 6.54 17.74 13.28 17.94 13.75 21.59 22.3 22.45 24.33 23.48 26.79 29.8 26.79 18.07 0.64 11.72 0.64' }),
	          _react2.default.createElement('polygon', { className: 'logo', points: '217.46 0.64 211.12 0.64 199.4 26.79 205.67 26.79 206.82 24.07 207.58 22.3 209.77 17.15 211.05 14.13 214.29 6.54 217.14 13.28 217.34 13.75 220.98 22.3 221.85 24.33 222.88 26.79 229.19 26.79 217.46 0.64' }),
	          _react2.default.createElement('polygon', { className: 'logo', points: '53.32 0.64 47.49 0.64 47.49 26.78 66.39 26.78 66.39 21.44 53.32 21.44 53.32 0.64' }),
	          _react2.default.createElement('path', { className: 'logo', d: 'M79.34,5.83h8v21h5.79v-21h8V.64H79.34Z' }),
	          _react2.default.createElement('polygon', { className: 'logo', points: '170.94 0.64 165.12 0.64 165.12 26.78 184.01 26.78 184.01 21.44 170.94 21.44 170.94 0.64' }),
	          _react2.default.createElement('path', { className: 'logo', d: 'M131.74,0a13.69,13.69,0,1,0,13.68,13.69A13.69,13.69,0,0,0,131.74,0Zm0,22.15a8.46,8.46,0,1,1,8.46-8.46A8.45,8.45,0,0,1,131.74,22.15Z' })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(15);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _moment = __webpack_require__(81);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post = function (_React$Component) {
	  _inherits(Post, _React$Component);
	
	  function Post() {
	    _classCallCheck(this, Post);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Post.prototype.render = function render() {
	    var _props$data$node$fron = this.props.data.node.frontmatter,
	        title = _props$data$node$fron.title,
	        date = _props$data$node$fron.date,
	        category = _props$data$node$fron.category,
	        description = _props$data$node$fron.description,
	        authorName = _props$data$node$fron.authorName,
	        authorPic = _props$data$node$fron.authorPic,
	        authorLink = _props$data$node$fron.authorLink;
	    var _props$data$node$fiel = this.props.data.node.fields,
	        slug = _props$data$node$fiel.slug,
	        categorySlug = _props$data$node$fiel.categorySlug;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'post' },
	      _react2.default.createElement(
	        'div',
	        { className: 'post__meta' },
	        _react2.default.createElement(
	          'time',
	          { className: 'post__meta-time', dateTime: (0, _moment2.default)(date).format('MMMM D, YYYY') },
	          (0, _moment2.default)(date).format('DD MMMM YYYY')
	        ),
	        _react2.default.createElement('span', { className: 'post__meta-divider' }),
	        _react2.default.createElement(
	          'span',
	          { className: 'post__meta-category', key: categorySlug },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: categorySlug, className: 'post__meta-category-link' },
	            category
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'h2',
	        { className: 'post__title' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__title-link', to: slug },
	          title
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'post__titledescription' },
	        _react2.default.createElement(
	          'blockquote',
	          { className: 'post__description' },
	          description,
	          '...'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: 'post__readmore', to: slug },
	          'Read more'
	        )
	      )
	    );
	  };
	
	  return Post;
	}(_react2.default.Component);
	
	exports.default = Post;
	module.exports = exports['default'];

/***/ }),

/***/ 56:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Post = __webpack_require__(45);
	
	var _Post2 = _interopRequireDefault(_Post);
	
	var _Sidebar = __webpack_require__(27);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(89);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexRoute = function (_React$Component) {
	  _inherits(IndexRoute, _React$Component);
	
	  function IndexRoute() {
	    _classCallCheck(this, IndexRoute);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  IndexRoute.prototype.render = function render() {
	    var items = [];
	    var _props$data$site$site = this.props.data.site.siteMetadata,
	        title = _props$data$site$site.title,
	        subtitle = _props$data$site$site.subtitle,
	        copyright = _props$data$site$site.copyright;
	
	    var posts = this.props.data.allMarkdownRemark.edges;
	    posts.forEach(function (post) {
	      items.push(_react2.default.createElement(_Post2.default, { data: post, key: post.node.fields.slug }));
	    });
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subtitle }),
	        _react2.default.createElement('link', { key: 'icon', rel: 'icon', href: '/favicon-16x16.png' }),
	        _react2.default.createElement('link', { rel: 'apple-touch-icon', sizes: '180x180', href: '/apple-touch-icon.png' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '32x32', href: '/favicon-32x32.png' }),
	        _react2.default.createElement('link', { rel: 'icon', type: 'image/png', sizes: '16x16', href: '/favicon-16x16.png' }),
	        _react2.default.createElement('link', { rel: 'mask-icon', href: '/safari-pinned-tab.svg', color: '#5bbad5' }),
	        _react2.default.createElement('meta', { name: 'msapplication-TileColor', content: '#da532c' }),
	        _react2.default.createElement('meta', { name: 'theme-color', content: '#ffffff' }),
	        _react2.default.createElement('link', { rel: 'canonical', href: 'https://altola.co/thinking' })
	      ),
	      _react2.default.createElement(_Header2.default, null),
	      _react2.default.createElement(_Sidebar2.default, this.props),
	      _react2.default.createElement(
	        'div',
	        { className: 'content' },
	        _react2.default.createElement(
	          'div',
	          { className: 'content__inner' },
	          items,
	          _react2.default.createElement(
	            'p',
	            { className: 'sidebar__copyright' },
	            copyright
	          )
	        )
	      )
	    );
	  };
	
	  return IndexRoute;
	}(_react2.default.Component);
	
	exports.default = IndexRoute;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-jsx-8074526a4c691292f835.js